import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import SubChildContent from './SubChildContent';
import SubChildHeader from './SubChildHeader';
import { useLocation, useParams } from 'react-router-dom';
import AboutSection from '../aboutsection/AboutSection';
import { API_ENDPOINTS, SITE_URL, toAbsoluteUrl } from '../../assets/helpers/AssetHelpers';
import { getCMSCategory, getCMSContent } from '../../services/api/Api';
import { setPageTitle } from '../../utils/setPageTitle';
interface Category {
	new_id: string;
	id: string;
	category_name: string;
	parent_cms_category: string | null;
}
interface ApiResponse {
	data: {
		all_category: Category[];
	};
}

interface CmsContent {
	id: string;
	content: string;
}

interface ApiResponse2 {
	data2: any[];
}

const SubChildCategory = () => {
	const { category_name, child_category_name, child } = useParams();

	const [data1, setData1] = useState<ApiResponse>({
		data: {
			all_category: [],
		},
	});

	const fetchCMSCategory = async () => {
		try {
			const response = await getCMSCategory(`site=${SITE_URL}`);
			setData1(response);
		} catch (error) {
			console.log('FetchCms Category error');
		}
	};

	useEffect(() => {
		// const fetchCMSCategory = async () => {
		// 	try {
		// 		const response = await fetch(API_ENDPOINTS.getCMSCategory, {
		// 			method: 'POST',
		// 			headers: new Headers({
		// 				'Content-Type': 'application/x-www-form-urlencoded',
		// 			}),
		// 			body: `site=${SITE_URL}`,
		// 		});

		// 		const data = await response.json();
		// 		setData1(data);
		// 	} catch (error) {
		// 		console.error('Error fetching CMS category:', error);
		// 	}
		// };

		fetchCMSCategory();
	}, []);
	const MainCategoryTitle = data1.data.all_category.filter((data) => data.new_id === category_name);
	const formattedMainCategoryTitle = MainCategoryTitle[0]?.category_name;
	const newTitle = data1.data.all_category.filter(
		(data: Category) => data.new_id === child_category_name,
	);
	const formattedNewChildCategoryTitle = newTitle[0]?.category_name;

	const newChildTitle = data1.data.all_category.filter((data: Category) => data.new_id === child);
	const formattedNewChildTitle = newChildTitle[0]?.category_name;
	useEffect(() => {
		if (formattedNewChildTitle) {
			setPageTitle(formattedNewChildTitle);
		}

		// Optional cleanup to reset the title when component unmounts
		return () => {
			setPageTitle('Jainam Support'); // Or your default title
		};
	}, [formattedNewChildTitle]);

	const [data2, setData2] = useState<[]>([]);

	const fetchCMSContents = async () => {
		try {
			const response = await getCMSContent(`cms_category=${formattedNewChildTitle}`);
			if (response && response.data) {
				setData2(response.data);
			} else {
				console.error('Invalid API response format:', response);
			}
		} catch (error) {
			console.error('Error fetching CMS content:', error);
		}
	};

	useEffect(() => {
		fetchCMSContents();
	}, [formattedNewChildTitle]);

	const filteredData = data1?.data?.all_category?.map((item: any) => {
		const subcategories = data2?.filter(
			(content: any) => content.cms_category === item.category_name,
		);
		const newItem = {
			...item,
			subcategories,
		};

		return newItem;
	});
	const mappedData = filteredData?.filter(
		(filterData: any) => filterData?.parent_cms_category === formattedNewChildCategoryTitle,
	);

	const childList = mappedData?.filter(
		(item: { category_name: any }) => item?.category_name === formattedNewChildTitle,
	);

	const getSubcategories = (parentCategory: any, allCategories: any) => {
		const subcategories = allCategories.filter(
			(category: any) => category.parent_cms_category === parentCategory.id,
		);

		if (subcategories.length === 0) {
			return null;
		}

		return subcategories.map((subcategory: any) => ({
			...subcategory,
			subcategories: getSubcategories(subcategory, allCategories),
		}));
	};
	const nestedCategories = data1?.data?.all_category
		.filter(
			(category) => category.parent_cms_category === null || category.parent_cms_category === '',
		)
		.map((category) => ({
			...category,
			subcategories: getSubcategories(category, data1?.data?.all_category),
		}));
	const subcategoriesArray = nestedCategories.flatMap((category) => category.subcategories);
	const filteredCategory = subcategoriesArray.filter(
		(item: any) => item?.title === child_category_name,
	);
	return (
		<>
			<section>
				<div className="container">
					<div className="row">
						<div className="col my-lg-5">
							<div className="row">
								<div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">
									<SubChildHeader
										MainCategoryTitle={formattedMainCategoryTitle}
										childCategoryName={formattedNewChildCategoryTitle}
										childName={formattedNewChildTitle}
									/>
									<div className="row">
										<div className="col-lg-3 col-12 mt-lg-2 d-none">
											<div className="accordion" id="sideBarAccordian">
												{nestedCategories.map((category: any, index: any) => {
													return (
														<>
															<Sidebar
																category_name={category.id}
																category={category}
																index={index}
																url_category_name={category_name}
																url_child_category_name={child_category_name}
															/>
														</>
													);
												})}
											</div>
										</div>
										<div
											className="col-lg-8 col-12 mt-lg-4 my-4 d-lg-block d-md-block d-none p-1"
											style={{ width: '100%' }}>
											<div className=" color3 decoration">
												<h5 className="py-2 color1 fs-24 in_semi px-2">{formattedNewChildTitle}</h5>
												{childList.length > 0 ? (
													<div className="accordion font-title" id="subContent">
														{childList.map((item: any, index: number) => {
															return (
																<>
																	<SubChildContent
																		filteredCategory={item}
																		category_name={category_name}
																		child_category_name={child_category_name}
																		child={child}
																		index={index}
																	/>
																</>
															);
														})}
													</div>
												) : (
													<div className="border-0 text-center">
														<img
															src={toAbsoluteUrl('about-section/no-faq.svg')}
															alt="no_data_found"
															style={{ width: '200px' }}
														/>
														<div className="row">
															<p className="fs-6 py-2 bw_semi col-8 mt-4 mx-auto">
																Looks like there are no FAQs here yet, but don’t worry—more helpful
																information is coming soon!
															</p>
														</div>
													</div>
												)}
											</div>
										</div>
										<div className="col-lg-8 col-12 mt-lg-4 my-4 d-lg-none d-md-none d-block">
											<div className="mx-lg-2 color3 decoration p-lg-3">
												<h5 className="py-2 color1 bw_semi px-lg-2">{formattedNewChildTitle}</h5>
												{childList.length > 0 ? (
													<div className="accordion font-title" id="subContent">
														{childList.map((item: any, index: number) => {
															return (
																<>
																	<SubChildContent
																		filteredCategory={item}
																		category_name={category_name}
																		child_category_name={child_category_name}
																		index={index}
																	/>
																</>
															);
														})}
													</div>
												) : (
													<div className="border-0 text-center">
														<img
															src={toAbsoluteUrl('about-section/no-faq.svg')}
															alt="no_data_found"
															style={{ width: '200px' }}
														/>
														<p className="fs-6 py-2 bw_semi mt-4">
															Looks like there are no FAQs here yet, but don’t worry—more helpful
															information is coming soon!
														</p>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default SubChildCategory;
